class IdleTimer {
    constructor({ localStorageIdleTimeName, onTimeout, onExpired, onInterval }) {
        this.localStorageIdleTimeName = localStorageIdleTimeName;
        this.pengkaliTimeOut = 60 * 60;
        this.pengkaliIntervalSecond = 1000;

        this.timeout = 0.5 * this.pengkaliTimeOut; /* 0.5 jam */
        this.intervalSecond = 120 * this.pengkaliIntervalSecond; /* 120 detik */

        // this.timeout = 10; /* detik */
        // this.intervalSecond = 1000; /* mili detik */

        this.onTimeout = onTimeout;
        this.onInterval = onInterval;

        const expiredTime = parseInt(localStorage.getItem(this.localStorageIdleTimeName) || 0, 10);

        if (expiredTime > 0 && expiredTime < Date.now()) {
            // console.log('onExpired');
            onExpired();
            // return;
            // ! apakah harus pakai return ?
        }

        this.eventHandler = this.updateExpiredTime.bind(this);
        this.tracker();
        this.startInterval();
    }

    startInterval() {
        this.updateExpiredTime();

        this.interval = setInterval(() => {
            const expiredTime = parseInt(localStorage.getItem(this.localStorageIdleTimeName) || 0, 10);

            if ((expiredTime - this.intervalSecond) < Date.now()) {
                if (this.onTimeout) {
                    // console.log('Timeout');
                    this.onTimeout();
                    this.cleanUp();
                }
            }

            // console.log((parseInt(localStorage.getItem(this.localStorageIdleTimeName) || 0, 10) - Date.now()) / 1000);
            this.onInterval();
        }, this.intervalSecond);
    }

    updateExpiredTime() {
        if (this.timeoutTracker) {
            clearTimeout(this.timeoutTracker);
        }

        this.timeoutTracker = setTimeout(() => {
            localStorage.setItem(this.localStorageIdleTimeName, Date.now() + this.timeout * 1000);
        }, 300);
    }

    tracker() {
        window.addEventListener("mousemove", this.eventHandler);
        window.addEventListener("scroll", this.eventHandler);
        window.addEventListener("keydown", this.eventHandler);
        window.addEventListener("click", this.eventHandler);
        window.addEventListener("wheel", this.eventHandler);
        window.addEventListener("touchstart", this.eventHandler);
    }

    cleanUp() {
        localStorage.removeItem(this.localStorageIdleTimeName);
        clearInterval(this.interval);

        window.removeEventListener("mousemove", this.eventHandler);
        window.removeEventListener("scroll", this.eventHandler);
        window.removeEventListener("keydown", this.eventHandler);
        window.removeEventListener("click", this.eventHandler);
        window.removeEventListener("wheel", this.eventHandler);
        window.removeEventListener("touchstart", this.eventHandler);
    }
}
export default IdleTimer;
